import includes from 'lodash/includes';

export const isRouteActive = (currentPath, path, exactPath) => {
  if (currentPath === path || (includes(currentPath, path) && !exactPath)) {
    return true;
  }
  return false;
};
